export default {
  'More in treatment group': 'rgb(255, 111, 44)',
  'Less in treatment group': 'rgb(208, 240, 253)',
  'Similar in treatment group': 'rgb(194, 245, 233)',
}
